// Constants for useCaptureLoadingTime hook
export const APP_LOAD_START_TIME = Date.now();
export const MIN_LOADING_TIME = 500; // milliseconds

// Image store URL constant (fallback)
export const COEFF_IMAGE_STORE_BASE_URL = "https://coeff-image-store.s3-us-west-2.amazonaws.com";

// WEBAPP_BASE_URL should be provided via props in addon context
export const WEBAPP_BASE_URL = "";

// FAQ links for IP whitelist info
export const FAQ_LINKS = {
  IP_WHITELIST: "https://help.coefficient.io/hc/en-us/articles/17969072042907",
};
